import { createFileRoute } from "@tanstack/react-router";
import { marketingUrl } from "../lib/marketing-url";

export const Route = createFileRoute("/terms-of-service")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      window.location.replace(`${marketingUrl}/terms-of-service`);
    }
  },
  component: () => null,
});
